import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import AnchorNavigationUtil from '@frontend/utils/AnchorNavigationUtil';

gsap.registerPlugin(ScrollTrigger);

export default class JumpLinks {
	private readonly element: HTMLElement;

	private static domSelectors = {
		link: '.m-jump-links__link[href^="#"]'
	};

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		this.initEvents();
		this.initAnimation();
	}

	protected initEvents(): void {
		const links = this.element.querySelectorAll(JumpLinks.domSelectors.link);

		links.forEach((link): void => {
			link.addEventListener('click', this.handleClick);
		});
	}

	protected handleClick = (event: Event): void => {
		event.preventDefault();

		const link = event.currentTarget as HTMLLinkElement;
		const target = link.getAttribute('href') as string;

		if (target) {
			AnchorNavigationUtil.goToAnchor(target);
		}
	};

	protected initAnimation = (): void => {
		if (window.matchMedia('(pointer: coarse)').matches) {
			let child = document.querySelector(`.m-jump-links__wrapper a:nth-child(1) .m-jump-links__image`);
			for (let i = 1; i < 6; i++) {
				child = document.querySelector(`.m-jump-links__wrapper a:nth-child(${i}) .m-jump-links__image`);
				if (child != null) {
					this.setAnimationMobile(child, i * 1.1);
				}
			}
		} else {
			const jumplinks = document.querySelectorAll('.m-jump-links__link');
			if (jumplinks != null) {
				jumplinks.forEach((value): void => {
					value.addEventListener('mouseenter', (): void => {
						gsap.to(value.firstChild, { rotation: -30, scale: 1.2, duration: 0.5 });
					});
					value.addEventListener('mouseleave', (): void => {
						gsap.to(value.firstChild, { rotation: 0, scale: 1, duration: 0.5 });
					});
				});
			}
		}
	};

	protected setAnimationMobile = (child: Element, delay: number): void => {
		const tl = gsap.timeline({ paused: true });

		tl.to(child, { duration: delay });
		tl.to(child, { rotation: -30, scale: 1.2, duration: 0.5 });
		tl.to(child, { rotation: 0, scale: 1, duration: 0.5 });

		ScrollTrigger.create({
			trigger: '.m-jump-links',
			start: 'center 90%',
			onEnter: (): void => {
				tl.play();
			}
		});
	};
}
